module.exports = __webpack_public_path__ + "img/ar.c5636400.png";